import { queryOptions } from "@tanstack/react-query";
import { apiFetch } from "./api-client";
import type { UserProfileResponse } from "./user-profile-schemas";

export const meProfileQueryOptions = queryOptions({
  queryKey: ["me", "profile"] as const,
  queryFn: () => apiFetch<UserProfileResponse>("/api/me/profile"),
  staleTime: 60_000,
});
